"use strict";

exports.__esModule = true;
exports.getFilteredPlantStateActivitiesList = getFilteredPlantStateActivitiesList;
var _getStatesForActivity = require("./getStatesForActivity");
/**
 * Filter the given list of activities using the given value filter term
 */
function getFilteredPlantStateActivitiesList(plantStateActivities) {
  return plantStateActivities.activities.filter(function (activity) {
    var states = (0, _getStatesForActivity.getStatesForActivity)(activity.id, plantStateActivities);
    var searchableTerm = activity.name + " " + activity.description + " " + states.map(function (map) {
      return map.state.name;
    }).join(" ");
    return searchableTerm.toUpperCase().includes(plantStateActivities.filterValue.toUpperCase());
  });
}